import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "variant", "value", "minValue", "maxValue", "interval", "onValueChange"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/QuantityInput/QuantityInput.js",
    _this = this;

import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import Text from '../Text';
import { Minus as MinusIcon, Plus as PlusIcon } from '@dls/assets/icons';
import { isNumber, noop } from '../../helpers';
import { withTheme, useTheme } from '../../core/ThemeProvider';
import { withClearInteraction } from '../../helpers/styled';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
var ACTION_INCREASE = 'ACTION_INCREASE';
var ACTION_DECREASE = 'ACTION_DECREASE';

var QuantityInput = function QuantityInput(_ref) {
  var text = _ref.text,
      variant = _ref.variant,
      value = _ref.value,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      interval = _ref.interval,
      onValueChange = _ref.onValueChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  useEffect(function () {
    isNumber(value) && setCurrentValue(value);
  }, [value]);

  var handleControlClick = function handleControlClick(action, flag) {
    if (flag) return;
    var value = parseInt(currentValue);
    var remainder = value % interval;
    var nextValue;

    if (action === ACTION_INCREASE) {
      nextValue = remainder ? value - remainder + interval : value + interval;
    } else {
      nextValue = remainder ? value - remainder : value - interval;
    }

    setCurrentValue(nextValue);
    onValueChange && onValueChange(nextValue);
  };

  var handleOnChange = function handleOnChange(event) {
    var newVal = event.target.value;
    if (newVal.startsWith('0')) newVal = newVal.slice(1);
    if (newVal > maxValue) newVal = maxValue;
    if (newVal < minValue || !newVal) newVal = minValue;
    setCurrentValue(newVal);
    onValueChange && onValueChange(newVal);
  };

  var disableDecreaseState = minValue >= currentValue;
  var disableIncreaseState = maxValue <= currentValue;
  var hasBorder = variant === 'whiteBox' || variant === 'haze';
  var backgroundColor = variant === 'haze' ? theme.cl_ter_l6 : theme.cl_white;
  return /*#__PURE__*/React.createElement(QuantityInputWrapper, {
    hasBorder: hasBorder,
    bgColor: backgroundColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LabelText, {
    type: "body",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }, text), /*#__PURE__*/React.createElement(ControlWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(RoundIcon, {
    disableAction: disableDecreaseState,
    enableInteraction: !disableDecreaseState,
    onClick: function onClick() {
      return handleControlClick(ACTION_DECREASE, disableDecreaseState);
    },
    "data-testid": "decreaseId",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    size: 15,
    color: rest.coreTheme.cl_white,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ValueText, {
    "data-testid": "valueId",
    value: currentValue,
    min: minValue,
    max: maxValue,
    onChange: handleOnChange,
    onKeyPress: function onKeyPress(event) {
      if (['.', '-', '+'].includes(event.key)) {
        event.preventDefault();
      }
    },
    onPaste: function onPaste(event) {
      event.preventDefault();
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(RoundIcon, {
    disableAction: disableIncreaseState,
    enableInteraction: !disableIncreaseState,
    onClick: function onClick() {
      return handleControlClick(ACTION_INCREASE, disableIncreaseState);
    },
    "data-testid": "increaseId",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    size: 15,
    color: rest.coreTheme.cl_white,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 11
    }
  }))));
};

QuantityInput.defaultProps = {
  value: 0,
  minValue: 0,
  maxValue: 10,
  interval: 1,
  onChange: noop
};
var RoundIcon = withTheme(withClearInteraction(styled.div.withConfig({
  displayName: "QuantityInput__RoundIcon",
  componentId: "sc-t7ewq3-0"
})(["display:flex;position:relative;background-color:", ";border-radius:32px;height:", "px;width:", "px;cursor:pointer;transition:0.1s all ease;justify-content:center;align-items:center;", ""], function (p) {
  return p.coreTheme.cl_sec_d1;
}, function (_ref2) {
  var _coreTheme$quantityIn, _coreTheme$quantityIn2;

  var coreTheme = _ref2.coreTheme;
  return (_coreTheme$quantityIn = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$quantityIn2 = coreTheme.quantityInput) === null || _coreTheme$quantityIn2 === void 0 ? void 0 : _coreTheme$quantityIn2.height) !== null && _coreTheme$quantityIn !== void 0 ? _coreTheme$quantityIn : 32;
}, function (_ref3) {
  var _coreTheme$quantityIn3, _coreTheme$quantityIn4;

  var coreTheme = _ref3.coreTheme;
  return (_coreTheme$quantityIn3 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$quantityIn4 = coreTheme.quantityInput) === null || _coreTheme$quantityIn4 === void 0 ? void 0 : _coreTheme$quantityIn4.width) !== null && _coreTheme$quantityIn3 !== void 0 ? _coreTheme$quantityIn3 : 32;
}, function (p) {
  var styleObject = {};

  if (p.disableAction) {
    styleObject.backgroundColor = p.coreTheme.cl_sec_l1;
    styleObject.cursor = 'default';
    styleObject['&:hover'] = {
      backgroundColor: p.coreTheme.cl_sec_l1
    };
  }

  return styleObject;
}), 8));
var QuantityInputWrapper = withTheme(styled.div.withConfig({
  displayName: "QuantityInput__QuantityInputWrapper",
  componentId: "sc-t7ewq3-1"
})(function (_ref4) {
  var hasBorder = _ref4.hasBorder,
      bgColor = _ref4.bgColor,
      coreTheme = _ref4.coreTheme;
  return css(["display:flex;align-items:center;", ""], hasBorder && css(["padding:", "px;background-color:", ";border-radius:", "px;"], coreTheme.space_4, bgColor, coreTheme.space_2));
}));
var ControlWrapper = withTheme(styled.div.withConfig({
  displayName: "QuantityInput__ControlWrapper",
  componentId: "sc-t7ewq3-2"
})(["display:flex;align-items:center;box-sizing:content-box;padding:", "px;"], function (p) {
  return p.coreTheme.space_2;
}));
var LabelText = withTheme(styled(Text).withConfig({
  displayName: "QuantityInput__LabelText",
  componentId: "sc-t7ewq3-3"
})(["flex:1 1 auto;", ";"], function (_ref5) {
  var _coreTheme$quantityIn5;

  var coreTheme = _ref5.coreTheme;
  return Object.assign({}, responsiveStyles({
    fontSize: ((_coreTheme$quantityIn5 = coreTheme.quantityInput) === null || _coreTheme$quantityIn5 === void 0 ? void 0 : _coreTheme$quantityIn5.fontSize) || coreTheme.fs_xl
  }, coreTheme));
}));
var ValueText = withTheme(styled.input.attrs({
  type: 'number'
}).withConfig({
  displayName: "QuantityInput__ValueText",
  componentId: "sc-t7ewq3-4"
})(["align-items:center;border:0;padding:0 16px;text-align:center;width:40px;appearance:textfield;background-color:transparent;", " ::-webkit-outer-spin-button,::-webkit-inner-spin-button{appearance:none;margin:0;}:focus{outline:none;}"], function (p) {
  var _p$coreTheme$quantity, _p$coreTheme, _p$coreTheme$quantity2;

  return css(["font-family:", ";", ";color:", ";", ""], (_p$coreTheme$quantity = (_p$coreTheme = p.coreTheme) === null || _p$coreTheme === void 0 ? void 0 : (_p$coreTheme$quantity2 = _p$coreTheme.quantityInput) === null || _p$coreTheme$quantity2 === void 0 ? void 0 : _p$coreTheme$quantity2.fontFamily) !== null && _p$coreTheme$quantity !== void 0 ? _p$coreTheme$quantity : p.coreTheme.ff_sec_bold, function (_ref6) {
    var _coreTheme$quantityIn6;

    var coreTheme = _ref6.coreTheme;
    return Object.assign({}, responsiveStyles({
      fontSize: ((_coreTheme$quantityIn6 = coreTheme.quantityInput) === null || _coreTheme$quantityIn6 === void 0 ? void 0 : _coreTheme$quantityIn6.fontSize) || coreTheme.fs_xl
    }, coreTheme));
  }, p.coreTheme.cl_sec_d3, function (_ref7) {
    var _coreTheme$quantityIn7, _coreTheme$quantityIn8;

    var coreTheme = _ref7.coreTheme;
    return ((_coreTheme$quantityIn7 = coreTheme.quantityInput) === null || _coreTheme$quantityIn7 === void 0 ? void 0 : _coreTheme$quantityIn7.fontWeight) && "\n    font-weight: ".concat((_coreTheme$quantityIn8 = coreTheme.quantityInput) === null || _coreTheme$quantityIn8 === void 0 ? void 0 : _coreTheme$quantityIn8.fontWeight, "\n  ");
  });
}));
export default withTheme(QuantityInput);